module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_wayo_studio@2x-56a9b15a4b51e4cb909243ea89c8fb1f.webp";